import { Checkbox, CheckboxProps, styled } from "@mui/material";
import React from "react";

export const CheckboxMenu = styled(Checkbox)<CheckboxProps>(({ theme }) => ({
  color: theme.palette.text.disabled,
  borderColor: theme.palette.text.disabled,
})) as React.ComponentType<CheckboxProps>;
